import { useState } from "react";
import axios from "axios";
import { composeApiURL } from "helpers/utility/axiosHelpers";
import { CardItem } from "views/components/LabelPropagation/SelectedClassesListStep/ClassCard";
import { SeedData, ClusterData, SampleData } from "./useGetSeed";
import { toast } from "react-toastify";
import VLToastComponent from "views/components/VLToastComponent";

export const useSendSeedAssignment = () => {
  const [cardItems, setCardItems] = useState<CardItem[] | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const sendSeedAssignment = async (
    selectedCard: string,
    exportRequestData: any[],
    datasetId?: string | null,
    seedId?: string | null
  ) => {
    if (!seedId || !selectedCard || !exportRequestData.length) return;

    setLoading(true);
    setError(null);

    try {
      const HOST_URL = process.env.REACT_APP_API_ENDPOINT!;
      const url = composeApiURL(
        HOST_URL,
        `/flywheel/${datasetId}/seed/${seedId}`
      );

      const response = await axios.post<SeedData>(url, {
        seed_assignment: {
          [selectedCard]: exportRequestData,
        },
      });

      const items: CardItem[] = response.data.seed_sample_clusters.reduce<
        CardItem[]
      >((acc, seed) => {
        const filtered = seed.samples
          .filter((sample) => sample.label_category_id === selectedCard)
          .map((sample) => ({
            id: sample.id,
            imgUri: sample.image_uri,
          }));
        return acc.concat(filtered);
      }, []);

      const seedClusters = response.data.seed_sample_clusters.map(
        (cluster: ClusterData) => ({
          label: cluster.label,
          labelCategoryId: cluster.label_category_id,
          count: cluster.samples_count,
          items: cluster.samples.map((sample: SampleData) => ({
            id: sample.id,
            imgUri: sample.image_uri,
          })),
        })
      );

      setCardItems(items);
      return seedClusters;
    } catch (err) {
      const toastId = toast(
        <VLToastComponent
          title="Image assignment failed"
          status="ERROR"
          description={(err as Error).message}
          onClose={() => toast.dismiss(toastId)}
        />,
        { autoClose: 5000, closeButton: false, closeOnClick: false }
      );
      setError(err as Error);
      console.error(`Failed to send selection for ${selectedCard}`, err);
      return null;
    } finally {
      setLoading(false);
    }
  };

  return {
    cardItems,
    loading,
    error,
    sendSeedAssignment,
  };
};
